import * as React from 'react';
import { Card, MultiRowColumn, SimpleTable } from 'components';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { connect } from 'react-redux';
import { useEffectProcessing } from 'hooks';
import { MappedExpertChangeRequestType } from 'components/enums';

const AssignmentHistoryContainer: React.FC<IProps> = (props) => {
    const processing = useEffectProcessing(
      () => props.fetchExpertChanges({ id: props.profile ? props.profile.id : undefined }),
      [],
      () => props.clearExpertChangeRequests(),
    );

    const tableHeader = React.useMemo(() => ([
        { title: 'ДАТА', columnStyles: { width: '10%' } },
        { title: 'ВНЕСЕННОЕ ИЗМЕНЕНИЕ' },
    ]), []);

    const tableRows = React.useMemo(() => (props.expertChanges ? props.expertChanges.items.map(ec => ({
        id: ec.id,
        columns: [
            ec.dateTime.format('DD.MM.YYYY'),
            <MultiRowColumn
              rows={[
                  MappedExpertChangeRequestType[ec.requestType],
                  ec.attestationSubCommissionName,
                  ec.newExpertStatus,
              ]}
            />,
        ],
    })) : []), [props.expertChanges]);

    return (
      <Card
        withoutPadding
        showLoader={processing}
        show404Error={!!props.apiError}
        title="История назначений"
        category="История включений/исключений из составов комиссий"
      >

          <SimpleTable
            tableRows={tableRows}
            tableHeaders={tableHeader}
            handleRowClick={() => true}
          />
      </Card>
    );
};

type ConnectedProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
type IProps = ConnectedProps;

const mapStateToProps = (state: IRootState) => ({
    expertChanges: state.expertChanges.historyExpertChanges,
    profile: state.auth.auth ? state.auth.auth.profile : null,
    apiError: state.errors.error,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchExpertChanges: dispatch.expertChanges.getExpertChangeRequestsHistory,
    clearExpertChangeRequests: () => dispatch.expertChanges.setHistoryExpertChangeRequests(null),
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentHistoryContainer);
